<template>
    <NuxtLayout>
        <div class="container">
            <div class="p-4 my-8 text-lg bg-danger-100 text-danger-900 rounded-sm">
                {{ message }}
            </div>
            <div v-if="isDev">
                <div class="text-base font-bold">{{ props.error.message }}</div>
                <div v-html="props.error.stack"></div>
            </div>
        </div>
    </NuxtLayout>
</template>
<script setup lang="ts">
import type { NuxtError } from "#app";

const isDev = import.meta.dev;
const { t } = useI18n();
const initializeState = useInitializeState();

const props = defineProps<{ error: NuxtError }>();

await initializeState();

useHead({ title: t("Global.TitleDefault") });

const message = computed(() => {
    let key = "ErrorPage.Generic";
    if (props.error.status === 403) key = "ErrorPage.Forbidden";
    if (props.error.status === 404) key = "ErrorPage.NotFound";
    return t(key);
});
</script>
